// Start the next item as soon as a worker finishes; preserve input order in the result.
interface RunConcurrentRequestsParams<TItem, TResult> {
    items: ReadonlyArray<TItem>;
    limit: number;
    request: (item: TItem) => Promise<TResult>;
    isCancelled: () => boolean;
}

export const runConcurrentRequests = <TItem, TResult>({
    items,
    limit,
    request,
    isCancelled
}: RunConcurrentRequestsParams<TItem, TResult>) => {
    const results: TResult[] = [];
    let next = 0;
    const runNext = async (): Promise<void> => {
        if (isCancelled() || next >= items.length) return;
        const index = next++;
        results[index] = await request(items[index]);

        return runNext();
    };

    return Promise.all(Array.from({ length: Math.min(items.length, limit) }, runNext)).then(() => results);
};
